import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { type Community } from "./entity";

export const CommunityEntityConfig: HyperEntityConfig<Community> = {
  allowApiRead: Allow.authenticated,
  allowApiCrud: [Roles.Admin, Roles.SuperAdmin, Roles.Manager],
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, false);

    filter(Roles.OrganizationManagers, {
      organization: {
        $id: remult.user.organizationId,
      },
    });

    filter(Roles.User, {
      associations: {
        $some: {
          associationId: {
            $in: remult.user.associations ?? [],
          },
        },
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(
      Roles.OrganizationManagers,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });
  },

  saving(entity) {
    if (!entity.parentCommunityId) {
      entity.parentCommunityId = "";
    }
  },
};
